console.log('[GLOBAL]', 'JS file loaded');

// Custom Js for how to use page
document.addEventListener('DOMContentLoaded', function () {
    const howToUseNavbar = document.querySelector(".section-how-to-use-navbar");
    
    if (howToUseNavbar) {

      function centerNavLink(el) {
        const container = el.closest('.section-how-to-use-navbar');
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const linkRect = el.getBoundingClientRect();

        const scrollLeft = container.scrollLeft
        + (linkRect.left - containerRect.left)
        - (containerRect.width / 2)
        + (linkRect.width / 2);

        container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
        });
      }

        (function () {
            const navbar = document.querySelector('.section-how-to-use-navbar');

            if (navbar && navbar.parentElement) {
            navbar.parentElement.classList.add('how-to-use-navbar-container');
            }
        })();

        (function () {
        'use strict';

        function formatToClass(str) {
            return str
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        function isMobile() {
          return window.matchMedia('(max-width: 749px)').matches;
        }

        function getHeaderOffset() {
          const header = document.querySelector('.header, .site-header, .sticky-header');
          const navbar = document.querySelector('.section-how-to-use-navbar');

          const headerHeight = header ? header.offsetHeight : 0;
          const navbarHeight = navbar ? navbar.offsetHeight : 0;

          let offset = headerHeight + navbarHeight;

          if (isMobile()) {
              offset -= 100;
          }

          return offset;
        }

        function scrollWithOffset(el) {
          if (isMobile()) {
            console.log('Mobile detected, adjusting offset');
            var offset = getHeaderOffset() + 100;
          }else {
            console.log('Desktop detected, adjusting offset');
            var offset = getHeaderOffset() + 60;
          }

            const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
            top,
            behavior: 'smooth'
            });
        }

       function findTargetEl(targetValue) {
          const items = document.querySelectorAll('.section-howtouse-product-item[data-howtouse-target]');
          let match = null;
          items.forEach(item => {
            if (formatToClass(item.dataset.howtouseTarget) === targetValue) {
              match = item;
            }
          });
          return match;
      }

        const navLinks = document.querySelectorAll('.section-how-to-use-navbar a');

        if (navLinks.length) {
            navLinks[0].classList.add('active');
        }



        navLinks.forEach(link => {
            link.addEventListener('click', function (e) {
            e.preventDefault();

            const targetValue = formatToClass(this.textContent);
            const targetEl = findTargetEl(targetValue);

            if (!targetEl) return;

            scrollWithOffset(targetEl);
            centerNavLink(this);

            navLinks.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
            });
        });


        function setActiveLink(matchingLink) {
    navLinks.forEach(l => l.classList.remove('active'));
    matchingLink.classList.add('active');
    centerNavLink(matchingLink);
}

function findLinkForSection(sectionEl) {
    const sectionValue = formatToClass(sectionEl.dataset.howtouseTarget);
    let match = null;
    navLinks.forEach(link => {
    if (formatToClass(link.textContent) === sectionValue) {
        match = link;
    }
    });
    return match;
}

const sections = document.querySelectorAll('.section-howtouse-product-item[data-howtouse-target]');

if (sections.length) {
    const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        const matchingLink = findLinkForSection(entry.target);
        if (matchingLink) {
            setActiveLink(matchingLink);
        }
        }
    });
    }, {
    root: null,
    rootMargin: `-${getHeaderOffset()}px 0px -70% 0px`,
    threshold: 0
    });

    sections.forEach(sec => observer.observe(sec));
}



        })();
    }
});

// Fix for alternate product images displaying incorrectly on iOS
document.addEventListener('DOMContentLoaded', function () {

        if (window.innerWidth >= 750) return;
        var sliders = document.querySelectorAll('.section-resource-list .resource-list__slide');

        sliders.forEach(function (slider) {
            var slides = slider.querySelectorAll('slideshow-slides slideshow-slide');

            slides.forEach(function (slide, i) {
            if (i === 0) return; // keep first one
            slide.remove();      // remove all others
            });
        });
});

// T&C scroll Navigation
document.querySelectorAll('.scroll-link').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const target = document.querySelector(targetId);
    const header = document.querySelector('header'); // change to your header selector

    if (target) {
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 20; // 20px breathing room

      const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
      const startTop = window.scrollY;
      const distance = targetTop - startTop;
      const duration = 1000;
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animateScroll(currentTime) {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        window.scrollTo(0, startTop + distance * easeInOutCubic(progress));

        if (progress < 1) requestAnimationFrame(animateScroll);
      }

      requestAnimationFrame(animateScroll);
    }
  });
});

if (document.body.classList.contains('template-collection')) {
  document.querySelectorAll('.collection-product-group__title').forEach(el => {
    el.setAttribute(
      'data-collection-name',
      el.textContent.trim().toLowerCase().replace(/\s+/g, '-')
    );
  });
}

document.addEventListener("click", function (e) {
  const link = e.target.closest('.policy-link a[href^="#"]');

  if (!link) return;

  const href = link.getAttribute("href");
  const target = document.querySelector(href);

  if (!target) return;

  e.preventDefault();

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }
  if (isMobile()) {
    var offsetValue = link.closest('[data-sticky-state="inactive"]') ? 100 : 100;
  }else {
    var offsetValue = link.closest('[data-sticky-state="inactive"]') ? 100 : 150;
  }

  const targetTop =
    target.getBoundingClientRect().top + window.pageYOffset;

  const scrollTo = Math.max(targetTop - offsetValue, 0);

  window.scrollTo({
    top: scrollTo,
    behavior: "smooth"
  });
});

(function () {
  function setupPrivacyLink() {
    const selectors = [
      {
        selector: 'footer li a',
        text: 'YOUR PRIVACY CHOICES'
      },
      {
        selector: '.privacy_policy .Preferences',
        text: 'Preferences Center'
      }
    ];

    selectors.forEach(({ selector, text: targetText }) => {
      document.querySelectorAll(selector).forEach(link => {
        const text = link.textContent
          .replace(/\u200B/g, '')
          .replace(/\s+/g, ' ')
          .trim();

        if (text === targetText && !link.dataset.bound) {
          link.dataset.bound = 'true';

          link.removeAttribute('href');

          link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            console.log('Privacy link clicked');

            setTimeout(function () {
              if (window.UC_UI && window.UC_UI.showSecondLayer) {
                console.log('Opening Usercentrics');
                window.UC_UI.showSecondLayer();
              }
            }, 100);
          });
        }
      });
    });
  }

  setupPrivacyLink();

  new MutationObserver(setupPrivacyLink).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
